import axios from './axios-auth';

const addProgram = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/addprogram',
      data: params,
      method: 'POST',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from api folder while calling axios');
      });
  });

const getTotalPoints = async ({ current, pageSize, sortField, sortOrder, clientId }) => {
  try {
    return await axios.get(
      `/hr-adm/getuserpoints?pg_num=${current}&pg_size=${pageSize}&search_term=&sort_field=${sortField}&sort_order=${sortOrder}&user_type=0&lock_status_type=2&clientId=${clientId}`
    );
  } catch (e) {
    console.log(e);
  }
};

const getAuthorizedClients = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getauthorizedclients",
      method: "GET"
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch(() => {
        console.log("error while fetching authorized clients api")
      })
  });

const getProgrammes = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getuserprograms",
      params: params,
      method: "GET"
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch(() => {
        console.log("error from api folder while calling axios");
      });
  });

const getProgrammesList = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getprograms",
      data: params,
      method: "POST"
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch(() => {
        console.log("error from api folder while calling axios");
      });
  });

const getProgrammeByProgramId = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getprogramdetails",
      params: params,
      method: "GET"
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch(() => {
        console.log("error from api folder while calling program details by id")
      })
  })

const updateProgramNameById = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/updateprogramnamebyid",
      params: params,
      method: "PUT"
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch(() => {
        console.log("error from api update name")
      })
  })

const updateProgramById = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/updateprogrambyid",
      data: params,
      method: "PUT",
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch(() => {
        console.log("error from api update program")
      })
  })

const toggleStatusProgramContest = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/updateprogramstatusbyid",
      params: params,
      method: "PUT"
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch(() => {
        console.log("error from activate while calling api")
      })
  })

const getAllProgramByClient = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getuserprograms",
      params: params,
      method: "GET"
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch(() => {
        console.log("error while response in get all program by client")
      })
  })

const editAllProgramOrContest = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/editclientprograms",
      data: params,
      method: "PUT"
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch(() => {
        console.log("error from edit all programs api")
      })
  })


export { addProgram, getTotalPoints, getAuthorizedClients, getProgrammes, getProgrammeByProgramId, updateProgramNameById, updateProgramById, toggleStatusProgramContest, getAllProgramByClient, editAllProgramOrContest, getProgrammesList };
